// extracted by mini-css-extract-plugin
module.exports = {"webRoot":"webRoot___v09H3","footer":"footer___374Hn","unit":"unit___35GY6","total":"total___2vRGv"};